module.exports = __webpack_public_path__ + "img/warnings-09.5b60bf3f.png";